import { useNavigate } from "react-router-dom";
import "Benchmarking/Scss/InstitutionCard.scss";

const InstitutionCard = ({ data, compareList, setCompareList }) => {
  const navigate = useNavigate();
  return (
    <div
      className="institution-card-profile"
      style={{
        boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.15)",
        // border: "1px solid var(--benchmarking-color)",
        padding: "10px",
        borderRadius: "10px",
        minHeight: "146px",
      }}
    >
      <div
        style={{ display: "flex", marginBottom: "10px", cursor: "pointer" }}
        onClick={() => navigate(`/benchmarking/institution/profile/${data.id}`)}
      >
        <div style={{ position: "relative", width: "40px", height: "40px" }}>
          <img
            src={
              data.photo_url
                ? data.photo_url
                : "https://www.openmicroscopy.org/img/icons/user-groups_institutions.svg"
            }
            alt="avatar"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              objectFit: "cover",
            }}
          />
          <svg
            style={{
              width: "18px",
              height: "18px",
              position: "absolute",
              right: -3,
              bottom: -3,
            }}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.592 9.46049C16.8463 9.13353 16.7874 8.66232 16.4605 8.40802C16.1335 8.15372 15.6623 8.21262 15.408 8.53958L11.401 13.6914C11.3119 13.806 11.1443 13.8209 11.0364 13.7238L8.50173 11.4426C8.19385 11.1655 7.71963 11.1904 7.44254 11.4983C7.16544 11.8062 7.1904 12.2804 7.49828 12.5575L10.033 14.8387C10.7881 15.5183 11.9613 15.4143 12.585 14.6123L16.592 9.46049Z"
              fill="var(--benchmarking-color)"
            />
          </svg>
        </div>
        <div style={{ marginLeft: "15px" }}>
          <p style={{ fontWeight: "600" }}>{data.name}</p>
        </div>
      </div>
      <div className="bio">
        <p>{data.bio}</p>
      </div>
      {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Tooltip title="See more information">
          <svg
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              console.log(data);
            }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="faculty-info-button"
          >
            <path
              d="M12 8V9M12 11.5V16M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="faculty-info-path"
            />
          </svg>
        </Tooltip>
        <Tooltip
          title={
            compareList.some((item) => item.id === data.id)
              ? "Already on list"
              : "Add to compare"
          }
        >
          <svg
            onClick={handleAddCompare}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={
              compareList.some((item) => item.id === data.id)
                ? "no-add"
                : "add-compare-button"
            }
          >
            <path
              d="M12 8V16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="add-compare-path"
            />
          </svg>
        </Tooltip>
      </div> */}
    </div>
  );
};

export default InstitutionCard;
